import { InternalCustomer } from 'types/GlobalCustomer'
import { TSignedInAccount } from 'types/GlobalAccount'

// Accounts that have access to developer customers
const DEVELOPER_ACCOUNTS = [
  'love.malmros',
  'kevin.kimaryo',
  'axel',
  'jonatan.jonsson'
]

// Developer customers that should only be accessible to developer accounts
const DEVELOPER_CUSTOMER_IDS = [
  '14f2d491-705f-42b3-929e-aefd085e7491', //Hogia demo
  '2eaacbcc-d0c5-4b5d-9cca-a307b2a5d79f', //ARC Showroom
  '71f9ea61-abf5-440a-95a0-56df12a30163', //Demo (Hemsida)
  '747c1a88-1b5f-4abe-bf11-17b4ca8fda3c', //Love och Lommas fastigheter
  '97be83b5-85d5-42db-9be4-5e8a2c47efad', //Hogia
  'dc49940e-fb46-4aa1-9079-6951d17f2d37', //LekSandbox
  'e80013ae-9dbc-4ffc-8ed5-738f5ad7ce57' //Sveaviken Showroom
]

// Filters customers based on the user and predefined exceptions
export function includeCustomer(
  user: TSignedInAccount | null,
  customer: InternalCustomer
): boolean {
  if (!user) return false

  const isDeveloperAccount = !!DEVELOPER_ACCOUNTS.find((acc) =>
    user.email.includes(acc)
  )
  const isDeveloperCustomer = !!DEVELOPER_CUSTOMER_IDS.includes(customer.id)
  const isDemo = customer.is_demo && customer.using_demo_data
  const isHomepalDemoMaster = user.is_homepal_demo_master

  if (isDeveloperCustomer && !isDeveloperAccount) {
    return false
  }

  if (!isHomepalDemoMaster) {
    return true
  }

  return isDemo
}
